/**
 * Mounts the floating walkthrough recorder once, inside the router but outside the page routes,
 * so it keeps recording while the prospect moves between pages (2026-09-28). See shared-ui's
 * WalkthroughRecorder. Renders nothing for anyone without an access code.
 */
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { WalkthroughRecorder } from 'shared-ui';
import { usePortal } from '../context/PortalContext';
import { getApiBaseUrl } from '../services/api';
import { pageNameFor, TOUR_STEPS } from '../config/pageNames';

export default function WalkthroughMount() {
  const { businessId, isSectionVisible } = usePortal();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const steps = TOUR_STEPS.filter((s) => s.always || !s.section || isSectionVisible(s.section));

  return (
    <WalkthroughRecorder
      apiBaseUrl={getApiBaseUrl()}
      businessId={businessId}
      pathname={pathname}
      navigate={navigate}
      pageNameFor={pageNameFor}
      steps={steps}
    />
  );
}
